import AJAX from 'common/AJAX';
import useMutation, { type MutationOptions } from 'common/hooks/useMutation';

import type { InsightDeleteData, InsightMoveData } from 'common/api/endpoints/insight';

export const useDeleteInsight = (options?: MutationOptions<string, InsightDeleteData>) => {
  return useMutation({
    mutationFn: async (input) => {
      const response = await AJAX.post('/api/insights/delete', input);
      return response;
    },
    ...options,
  });
};

export const useMoveInsight = (options?: MutationOptions<string, InsightMoveData>) => {
  return useMutation({
    mutationFn: async (input) => {
      const response = await AJAX.post('/api/insights/move', input);
      return response;
    },
    ...options,
  });
};
